import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@linaria/react';
import { AnimatePresence, motion } from 'framer-motion';
import { setScrollToApTarget } from 'modules/accommodation/slice';
import { AccommodationPageNavSections } from 'modules/accommodation/types';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/hooks/useDispatchTeamEvent';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "c1gfcs1v",
  propsAsIs: false
});
interface Props {
  isVisible: boolean;
  isLoading: boolean;
}
export const HeaderCTA: React.FC<Props> = ({
  isVisible,
  isLoading
}) => {
  const dispatchTeamEvent = useDispatchTeamEvent();
  const dispatch = useDispatch();
  const {
    isDesktopSm,
    isDesktopXs
  } = useDeviceLayout();
  const handleTrackOffer = useCallback(() => {
    dispatchTeamEvent(trackEvent({
      category: Category.System,
      entity: Entity.HotelDetailsStaticOfferCTA,
      action: Action.Displayed
    }));
  }, [dispatchTeamEvent]);
  useEffect(() => {
    if (!isLoading && isVisible) {
      handleTrackOffer();
    }
  }, [isVisible, isLoading, handleTrackOffer]);
  const handleClick = () => {
    dispatch(setScrollToApTarget({
      target: AccommodationPageNavSections.Rooms
    }));
  };
  const renderCTA = () => {
    if (isLoading) return <Container>
          <SkeletonLoader height={42} width={144} align="right" />
        </Container>;
    return <Container>
        <Button size="lg" variant="primary" onClick={handleClick}>
          <FormattedMessageWrapper id="viewRooms" defaultMessage="View rooms" />
        </Button>
      </Container>;
  };
  if (isDesktopSm || isDesktopXs) return null;
  return <AnimatePresence>
      {isVisible && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }}>
          {renderCTA()}
        </motion.div>}
    </AnimatePresence>;
};

require("./HeaderCTA.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HeaderCTA.tsx");